import {
    GET_USER_BIRTH_CHART_LIST,
    GET_USER_BIRTH_CHART_LIST_SUCCESS,
    GET_USER_BIRTH_CHART_LIST_FAIL,
    GET_BIRTH_CHART_REPORT
} from "./actionTypes"

export const getUserBirthChartList =
    (page, size, sortOrder, reportCreatedDate, reportCreatedEndDate, planet, position, userName, refferedBy, city, mobile, userType, groupMasterId, branchId, userId) => ({
        type: GET_USER_BIRTH_CHART_LIST,
        payload: { page, size, sortOrder, reportCreatedDate, reportCreatedEndDate, planet, position, userName, refferedBy, city, mobile, userType, groupMasterId, branchId, userId }
    })

export const getUserBirthChartListSuccess = birthChartListPage => ({
    type: GET_USER_BIRTH_CHART_LIST_SUCCESS,
    payload: birthChartListPage
})

export const getUserBirthChartListFail = error => ({
    type: GET_USER_BIRTH_CHART_LIST_FAIL,
    payload: error
})

export const getBirthChartReport = birthChartId => ({
    type: GET_BIRTH_CHART_REPORT,
    birthChartId,
})